var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 7.33334C13.0352 7.33334 13.3337 7.63182 13.3337 8.00001C13.3337 8.3419 13.0763 8.62368 12.7447 8.66219L12.667 8.66668H3.33366C2.96547 8.66668 2.66699 8.3682 2.66699 8.00001C2.66699 7.65812 2.92435 7.37634 3.25591 7.33783L3.33366 7.33334H12.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.13cc2f54ddca43b5cb9330a753b95da0.svg";
export { ForwardRef as ReactComponent };